export default __webpack_public_path__ + "static/media/rainforest6.a0bdb011.jpg";